/* Update only the native banner message; Shopify owns every consent action. */
(() => {
  const message = 'We use cookies to personalise content and ads, analyse traffic, and support social media features. We may also share usage data with our advertising, analytics and social media partners.';
  const selector = '#shopify-pc__banner';
  function updateMessage() {
    const paragraph = document.querySelector(`${selector} .shopify-pc__banner__body p`);
    if (!paragraph) return;
    const policyLink = paragraph.querySelector('#shopify-pc__banner__body-policy-link');
    const expected = message + (policyLink ? ` ${policyLink.textContent}` : '');
    if (paragraph.textContent === expected) return;
    paragraph.replaceChildren(document.createTextNode(message + (policyLink ? ' ' : '')));
    if (policyLink) paragraph.append(policyLink);
  }
  updateMessage();
  new MutationObserver(records => {
    const relevant = records.some(record =>
      record.target instanceof Element && record.target.closest(selector) ||
      [...record.addedNodes].some(node => node instanceof Element && (node.matches(selector) || node.querySelector(selector)))
    );
    if (relevant) updateMessage();
  }).observe(document.body, { childList: true, subtree: true });
})();
